import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.PageGrowthOverTimeView extends Monitoring.Reports.Executive.AbstractSectionView
  id: 'page-growth-over-time'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/page_growth_over_time"]

  render: ->
    @$el.html(@template({ subtitle: @getTemplateOptions().subtitle }))
    @addPageGrowthChart()
    return this

  addPageGrowthChart: ->
    facebookPageName = @getTemplateOptions().page
    data = {
      date_from_ISO: @options.fromISO.toISOString()
      date_to_ISO: @options.toISO.toISOString()
      page: facebookPageName
    }
    $.post(@options.chartApi.page_growth_over_time, data, (response) =>
      @lineVsLineGraph('#total_likes_over_time', 'Total page likes', response)
      @trigger('sectionReady')
    )

  # Copied and adapted from _common.html.erb

  lineVsLineGraph: (selector, title, seriesHash) ->
    @dualGraph(selector, title, seriesHash, 'line', 'line')

  dualGraph: (selector, title, seriesHash, type1, type2) ->
    axis = @getKeys(seriesHash);
    values = @getValues(seriesHash);
    $(selector).highcharts(
      chart:
        zoomType: 'xy'
        backgroundColor: null
      tooltip:
        shared: true
      title:
        text: null
      xAxis: [{
        type: 'datetime'
        labels:
          rotation: -90
        tickInterval: @tickInterval()
        dateTimeLabelFormats:
          day: '%d/%m/%Y'
      }],
      yAxis: [
        { title: { text: axis[1] } }
        { title: { text: axis[0] }, opposite: true }
      ],
      series: [{
        name: axis[0]
        type: type1
        yAxis: 1
        data: values[0]
      }, {
        name: axis[1]
        type: type2
        data: values[1]
      }]
    )

  getKeys: (hash) ->
    return _.map(hash, @getKey)

  getValues: (hash) ->
    return _.map(hash, @getValue)

  getKey: (v,k) ->
    return k.titleize()

  getValue: (v,k) ->
    if(v.length) #is an array?
      return _.map(v, (pair) ->
        return [ Date.parse(pair[0]), pair[1] ]
      )
    else
      return v

  tickInterval: ->
    unit = 'day'
    switch unit
      when 'month' then days = 30
      when 'week' then days = 7
      else days = 1
    return days*24*60*60*1000

  datetimeFormat = {
     day: '%d/%m/%Y'
  }
